import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import { TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import * as XCol from '../../../framework.core/XExportColumn';
import constants from '../../../constants';
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {shippingList} from "../tableSettings";
import {WhShipListItem} from "../../../fms.data/models/WhShipListItem";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BillingsIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useSelectedOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  
  const selectedElement = jobListContext.selectedElement as WhShipListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/warehousing/shipping/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    openNewPage(history, '/warehousing/shipping/add', NavigationType.newPage);
  }

  async function deleteShipping() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close Shipping first', false, null, "warning");
    //   return;
    // }

    if (selectedElement.shipStatus !== 'Pre Shipping') {
      await showGlobalOkDialog('Can delete the Pre Shipping', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/WHSHP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/WHSHP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/WHSHP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/WHSHP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/WHSHP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/WHSHP/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.WHShip, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/warehousing/shipping/edit/${selectedElement.id}`;
        const viewUrl = `/warehousing/shipping/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null,'warning');
      }
    }
  }
  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/warehousing/shipping/edit/${id}`;
    const viewUrl = `/warehousing/shipping/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/warehousing/shipping/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    if(selectedElement.isVoid){
      //const viewUrl = `/warehousing/shipping/view/${id}`;
      jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, [editUrl, viewUrl]);
    //}else if(selectedElement.isClosed){
    //   await showGlobalOkDialog(<p>File Locked. You can only edit Remark information fields</p>);
    //   openNewPage(history, `/warehousing/shipping/edit/${id}`, NavigationType.newPage);
    }else{
      jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
    }
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/warehousing/shipping/edit/${id}`;
    const viewUrl = `/warehousing/shipping/view/${id}`;

    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHShip, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function switchToAcctInfo(shp:WhShipListItem|null) {
    if (!shp) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.WHShip}/${shp.id}`, NavigationType.newPage);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings(isEdit : boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 1;
    const baseUrl = '/warehousing/shipping';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.WHShip}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  return {deleteShipping, create, edit, view, switchToAcctInfo, viewBillings};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteShipping, edit, view, viewBillings } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const selectedElement = jobListContext.selectedElement as WhShipListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHShip, selectedElement?.branch);
  const fmsGlobal = getFmsGlobal();
  const userID = appContext.user ? appContext.user.id ?? '' : '';


  async function processFileLock() {
    if(selectedElement.shipStatus !== 'Shipped'){
      await showGlobalOkDialog('Cannot op close before receipt confirm');
      return;
    }
    if(selectedElement.shipDate === null){
      await showGlobalOkDialog('Invalid OutDate');
      return;
    }
    const fileLockResult = await appContext.api.opClose(JobNames.WHShip, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult);
      return;
    }

     const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/view/${selectedElement.id}`)
    

    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editShipping${selectedElement.id}-/warehousing/shipping/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewShipping${selectedElement.id}-/warehousing/shipping/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;
      }
    }else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editShipping${selectedElement.id}-/warehousing/shipping/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewShipping${selectedElement.id}-/warehousing/shipping/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_WSHIPHD',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
      }
    }
    
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    if(selectedElement.shipStatus !== 'Shipped'){
      await showGlobalOkDialog('Cannot accounting close before receipt confirm');
      return;
    }
    if(selectedElement.shipDate === null){
      await showGlobalOkDialog('Invalid OutDate');
      return;
    }
    const accountLockResult = await appContext.api.accountClose(JobNames.WHShip, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult);
      return;
    }

     const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/warehousing/shipping/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editShipping${selectedElement.id}-/warehousing/shipping/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewShipping${selectedElement.id}-/warehousing/shipping/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
      }
      
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
      }
    }else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editShipping${selectedElement.id}-/warehousing/shipping/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewModelKey = `viewShipping${selectedElement.id}-/warehousing/shipping/view`;
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_WSHIPHD',
        fieldName: 'F_AcctCloseDate'
      });


      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
      }
      
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
      }
    }
    
    
    jobListContext.reloadData();
  }
  
  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Billings', shortcut: 'F7', separator: listSec?.grantEdit ?? false, hidden: noBillingsShow },
    // { label: !selectedElement?.isClosed ? 'File Lock' : 'Cancel File Lock', shortcut: '', separator: false },
    { label: selectedElement?.isClosed ? 'OP Open' : 'OP Close', shortcut: '', separator: false, hidden: !showFileLock },
    { label: selectedElement?.isAccountClosed ? 'Accounting Open' : 'Accounting Close', shortcut: '', separator: false, hidden: !showAccountLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="shipping-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteShipping();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        viewBillings(listSec?.grantEdit ?? false);
        break;
      case 7:
        processFileLock();
        break;
      case 8:
        processAccountLock();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as WhShipListItem;

  const { deleteShipping, edit, view ,viewBillings} = useSelectedOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const {switchJournal} = useJournal();
  

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.WHShip, selectedElement, appContext, showGlobalYesNoDialog, null);
    if(args){
      viewReport(args, "", true);
    }
  }

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHShip, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  
  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='shipping-list-add-button' display="primary" link="/warehousing/shipping/add" disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='shipping-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='shipping-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='shipping-list-delete-button' disabled={!canBeDeleted} onClick={deleteShipping} useText/>
      </div>
      <div className='ifms-common-vertical-gap-8'>
        {!noBillingsShow && <BillingsIconButton name='shipping-list-viewBillings-button' onClick={viewBillings} useText/>}
        {!checkSecJournal && <JournalIconButton onClick={() =>  switchJournal(JobNames.WHShip, selectedElement.id) } useText/>}
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as WhShipListItem;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.WHShip, selectedElement?.branch);

  const {create, edit, view, viewBillings} = useSelectedOperations();
    const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings(listSec?.grantEdit ?? false);
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F9") {
      view();
    } 

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3','F8', 'F7', 'F9'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.WHShip}
      //entityId={(jobListContext.selectedElement as WhShipListItem | null)?.id}
      jobId={(jobListContext.selectedElement as WhShipListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Warehouse Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.WHShip,
      'WhShipListItem',
      WhShipListItem.calculateSearchParameters(search, WhShipListItem.MapSearchFields, ['isVoid']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: WhShipListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.WHShip, 'WhShipListItem',
      WhShipListItem.calculateSearchParameters(search, WhShipListItem.MapSearchFields, ['isVoid']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return WhShipListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      // {
      //   accessor: 'isVoid',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v === 'V' ? 1 : 0,
      // },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    // return [
    //   {accessor: 'sstatus', Cell: IndicatorRenderer},
    //   {accessor: 'invStat', Cell: TextRenderer},
    //   {accessor: 'billStat', Cell: TextRenderer},
    //   {accessor: 'isVoid', Cell: NullableCheckboxIconRenderer},
    //   {accessor: 'shipNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'centerNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'branch', Cell: TextRenderer},
    //   {accessor: 'p', Cell: TextRenderer},
    //   {accessor: 'remark', Cell: TextAlignLeftRenderer},
    //   {accessor: 'palletRemark', Cell: TextAlignLeftRenderer},
    //   {accessor: 'trucker', Cell: TextAlignLeftRenderer},
    //   {accessor: 'shipToNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'poNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'totalQty', Cell: TextAlignLeftRenderer},
    //   {accessor: 'orderDate', Cell: DateTimeRenderer},
    //   {accessor: 'shipDate', Cell: DateTimeRenderer},
    //   {accessor: 'u2Date', Cell: DateTimeRenderer},
    //   {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
    //   {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
    // ];
    return WhShipListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      // else if (x.dataIndex === 'isVoid') colRenderer.Cell = VoidRenderer;
      else if (x.dataIndex === 'p') colRenderer.Cell = PaidRenderer;
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'totalQty')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }

      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'p', changedValue: (value: any)=> { return value['p']}});
    colRenderer.push({accessor: 'totalQty', changedValue: (value: any)=> { return value['totalQty']}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  shippingList;
    const cols = WhShipListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: WhShipListItem) {
    return row && row.id ? `/warehousing/shipping/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Shipping List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
